import { render, staticRenderFns } from "./UiDialog.vue?vue&type=template&id=73f5921d&"
import script from "./UiDialog.vue?vue&type=script&lang=js&"
export * from "./UiDialog.vue?vue&type=script&lang=js&"
import style0 from "./UiDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports